var render = function render(){var _vm=this,_c=_vm._self._c;return _c('nav',[_c('Button',{staticClass:"map-button",attrs:{"id":"back-button","to":{ name: 'Home' }}},[_c('ExitToApp',{staticClass:"flip",attrs:{"size":_vm.IconSize.Normal}}),_c('Locale',{attrs:{"path":"routes.home"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }